module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-315.cf98dae.woff2";